module.exports = __webpack_public_path__ + "static/img/over-distance.8732d44.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/icons/over-distance.png
// module id = YoH9
// module chunks = 1